import React, { Component } from "react";
import PropTypes from "prop-types";
import InvalidFeedback from "../../../common/invalid_feedback";

class CompanyForm extends Component {
  constructor(props) {
    super(props);

    this.state = {
      name: props.url_path_name,
      company: {
        name: props.name,
        website_url: props.website_url || "",
        concept_pitch: props.concept_pitch || "",
        url_path_name: props.url_path_name,
      },
      previewLogoImage: {
        url: props.logo_image
      },
      errors: {
        company: {},
      },
      isSaving: false
    };
  }

  componentDidUpdate(prevProps) {
    const { url_path_name } = this.props;
    if (url_path_name !== prevProps.url_path_name) {
      window.location = url_path_name;
    }
  }

  onCompanyChange = (event, value) => {
    const { company } = this.state;
    const field = event.target.name;
    company[field] = value == null ? event.target.value : value;
    this.setState({company: company});
  };

  onPreviewLogoImageChange = (event) => {
    const file = event.target.files[0];

    this.onCompanyChange(event, file);

    if (!file) return;
    if (/^image/.test(file.type)) {
      const reader = new FileReader();
      reader.onloadend = () => {
        this.setState({ previewLogoImage: { url: reader.result } });
      };
      reader.readAsDataURL(file);
    }
  }

  handleFormSubmit = (event) => {
    event.preventDefault();
    this.setState({isSaving: true});

    const { actions, handleEditButtonClick } = this.props;
    actions.updateCompany(this.state).then(() => {
      this.setState({isSaving: false});
      handleEditButtonClick();
    }).catch(errors => {
      this.setState({errors: errors, isSaving: false});
    });
  }

  render () {
    const { company, previewLogoImage, errors, isSaving } = this.state;
    const { defaultCompanyImage, handleEditButtonClick } = this.props;

    return (
      <div id='object-edit'>
        <div className='container'>
          <div className='row d-flex justify-content-center no-gutter'>
            <div className='col-12 col-lg-10'>
              <form>
                <div className='row form-group'>
                  <div className='col-12 text-center mb-3'>
                    <label htmlFor='company-logo-image'>
                      <span className='label-image-edit'>
                        <i className='fas fa-image' />
                        画像を編集
                      </span>
                      <span className='company-logo'>
                        <img
                          src={previewLogoImage.url || defaultCompanyImage}
                          alt='ロゴ'
                          className='img-thumbnail'
                        />
                      </span>
                      <input
                        name='logo_image'
                        className={"d-none custom-file-input" + `${errors.company.logo_image ? " is-invalid" : ""}`}
                        type='file'
                        id='company-logo-image'
                        onChange={this.onPreviewLogoImageChange}
                      />
                    </label>
                    <InvalidFeedback errors={errors.company.logo_image} label='ロゴ画像' />
                  </div>
                </div>

                <div className='row form-group'>
                  <div className='col-12 col-md-6'>
                    <label className='col-form-label' htmlFor='company-name'>会社名</label>
                  </div>
                  <div className='col-12 col-md-6'>
                    <input
                      name='name'
                      className={`${errors.company.name ? "form-control is-invalid" : "form-control"}`}
                      required='required'
                      type='text'
                      value={company.name}
                      id='company-name'
                      placeholder='サイバーエージェント ※「株式会社」などは省略'
                      onChange={this.onCompanyChange}
                    />
                    <InvalidFeedback errors={errors.company.name} label='会社名' />
                  </div>
                </div>

                <div className='row form-group'>
                  <div className='col-12 col-md-6'>
                    <label className='col-form-label' htmlFor='company-website-url'>WebサイトURL</label>
                  </div>
                  <div className='col-12 col-md-6'>
                    <input
                      name='website_url'
                      className={`${errors.company.website_url ? "form-control is-invalid" : "form-control"}`}
                      placeholder='https://'
                      type='text'
                      value={company.website_url}
                      id='company-website-url'
                      onChange={this.onCompanyChange}
                    />
                    <InvalidFeedback errors={errors.company.website_url} label='WebサイトURL' />
                  </div>
                </div>

                <div className='row form-group'>
                  <div className='col-12 col-md-6'>
                    <label className='col-form-label' htmlFor='company-concept-pitch'>経営理念</label>
                  </div>
                  <div className='col-12 col-md-6'>
                    <textarea
                      name='concept_pitch'
                      className={`${errors.company.concept_pitch ? "form-control is-invalid" : "form-control"}`}
                      placeholder='●●を●●●●に'
                      value={company.concept_pitch}
                      id='company-concept-pitch'
                      rows='5'
                      onChange={this.onCompanyChange}
                    />
                    <InvalidFeedback errors={errors.company.concept_pitch} label='経営理念' />
                  </div>
                </div>

                <div className='row form-group'>
                  <div className='col-12 col-md-6'>
                    <label className='col-form-label' htmlFor='company-url-path-name'>会社ID</label>
                  </div>
                  <div className='col-12 col-md-6'>
                    <input
                      name='url_path_name'
                      className={`${errors.company.url_path_name ? "form-control is-invalid" : "form-control"}`}
                      type='text'
                      value={company.url_path_name}
                      id='company-url-path-name'
                      onChange={this.onCompanyChange}
                    />
                    <InvalidFeedback errors={errors.company.url_path_name} label='会社ID' />
                    <p className='small'>
                      https://angl.jp/companies/
                      {company.url_path_name}
                    </p>
                  </div>
                </div>

                <div className='text-right mt-4'>
                  <input
                    type='button'
                    disabled={isSaving}
                    value='キャンセル'
                    className="btn btn-white mr-2"
                    onClick={handleEditButtonClick}
                  />
                  <input
                    type='button'
                    disabled={isSaving}
                    value={isSaving ? "保存中..." : "保存"}
                    className="btn btn-primary"
                    onClick={this.handleFormSubmit}
                  />
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

CompanyForm.propTypes = {
  name: PropTypes.string.isRequired,
  logo_image: PropTypes.string,
  website_url: PropTypes.string,
  concept_pitch: PropTypes.string,
  url_path_name: PropTypes.string.isRequired,
  actions: PropTypes.objectOf(PropTypes.func).isRequired,
  handleEditButtonClick: PropTypes.func.isRequired,
  defaultCompanyImage: PropTypes.string.isRequired
};

CompanyForm.defaultProps = {
  logo_image: "",
  website_url: "",
  concept_pitch: "",
};

export default CompanyForm;
